import React from 'react';
import { daysBetween, makeDate } from './data.jsx';
import { Icon } from './icons.jsx';
// Gestão de Inadimplência — régua de cobrança automática para tenants
const InadimplenciaPage = ({ onToast, stores }) => {
  const [saved,     setSaved]     = React.useState(false);
  const [activeTab, setActiveTab] = React.useState('regua');

  const [steps, setSteps] = React.useState([
    { id: 1, day: 0,  label: 'Vencimento',          enabled: true,  channel: 'email',           action: 'lembrete', title: 'Fatura vencida — regularize sua assinatura Tezus',      editable: false },
    { id: 2, day: 3,  label: '1° lembrete',          enabled: true,  channel: 'email',           action: 'lembrete', title: 'Sua assinatura está 3 dias em atraso',                  editable: true  },
    { id: 3, day: 7,  label: '2° lembrete',          enabled: true,  channel: 'whatsapp',        action: 'lembrete', title: 'Urgente: pagamento pendente há 7 dias',                 editable: true  },
    { id: 4, day: 15, label: 'Aviso de suspensão',   enabled: true,  channel: 'email',           action: 'aviso',    title: 'Sua loja será suspensa em 48 horas',                   editable: true  },
    { id: 5, day: 17, label: 'Suspensão automática', enabled: true,  channel: 'sistema',         action: 'suspender',title: 'Loja suspensa automaticamente',                        editable: false },
    { id: 6, day: 30, label: 'Aviso de cancelamento',enabled: false, channel: 'email',           action: 'aviso',    title: 'Sua loja será cancelada em 7 dias',                    editable: true  },
    { id: 7, day: 37, label: 'Cancelamento',         enabled: false, channel: 'sistema',         action: 'cancelar', title: 'Loja cancelada e dados agendados para exclusão',       editable: false },
  ]);

  const [config, setConfig] = React.useState({
    graceDays: 17, cancelDays: 37,
    pauseOnPayment: true, notifyAdmin: true,
    adminEmail: 'ana@tezus.com',
    retryPayment: true, retryInterval: 3, maxRetries: 3,
  });

  const setStepField = (id, field, value) => {
    setSteps(prev => prev.map(s => s.id === id ? { ...s, [field]: value } : s));
    setSaved(false);
  };
  const setCfg = (k) => (e) => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.type === 'number' ? Number(e.target.value) : e.target.value;
    setConfig(c => ({ ...c, [k]: v }));
    setSaved(false);
  };
  const handleSave = () => {
    setSaved(true);
    if (onToast) onToast('Régua de cobrança salva com sucesso');
  };

  const inadimplentes = stores.filter(s => s.status === 'inadimplente');
  const today = makeDate(0);

  const ACTIONS = {
    lembrete: { label: 'Lembrete',       color: 'var(--info)',    cls: 'info'    },
    aviso:    { label: 'Aviso crítico',  color: 'var(--warning)', cls: 'warning' },
    suspender:{ label: 'Suspender loja', color: 'var(--danger)',  cls: 'danger'  },
    cancelar: { label: 'Cancelar loja',  color: 'var(--danger)',  cls: 'danger'  },
  };

  const inputStyle = { height: 34, padding: '0 10px', borderRadius: 'var(--radius)', border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' };
  const lbl = (txt) => <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 6 }}>{txt}</div>;

  const TABS = [
    { id: 'regua',    label: 'Régua de cobrança' },
    { id: 'lojas',    label: `Lojas em atraso (${inadimplentes.length})` },
    { id: 'historico',label: 'Histórico de ações' },
  ];

  return (
    <div className="content" style={{ maxWidth: 1100 }}>
      <div className="page-header">
        <div>
          <h1>Gestão de inadimplência</h1>
          <p className="sub">Configure a régua de cobrança automática e acompanhe lojas em atraso.</p>
        </div>
        <div className="actions">
          <button className="btn" onClick={() => { if (onToast) onToast('Régua simulada para Dona Clara Doces'); }}>
            <Icon name="play" size={14} />Simular régua
          </button>
          <button className="btn primary" onClick={handleSave}>
            <Icon name="check" size={14} />{saved ? 'Salvo!' : 'Salvar alterações'}
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 24, gap: 2 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
            padding: '10px 16px', border: 'none', background: 'transparent', cursor: 'pointer',
            fontSize: 13, fontWeight: activeTab === t.id ? 600 : 400,
            color: activeTab === t.id ? 'var(--text)' : 'var(--text-muted)',
            borderBottom: activeTab === t.id ? '2px solid var(--brand-navy)' : '2px solid transparent',
            marginBottom: -1,
          }}>{t.label}</button>
        ))}
      </div>

      {/* ── TAB: Régua ── */}
      {activeTab === 'regua' && (
        <div className="grid-2" style={{ gridTemplateColumns: '1fr 320px', gap: 24, alignItems: 'start' }}>
          <div>
            <div className="card" style={{ marginBottom: 20 }}>
              <div className="card-head">
                <h3>Fluxo de cobrança</h3>
                <span className="sub">Disparado a partir da data de vencimento</span>
              </div>
              <div style={{ padding: '8px 0' }}>
                {steps.map((step, idx) => {
                  const act = ACTIONS[step.action];
                  const isSystem = step.action === 'suspender' || step.action === 'cancelar';
                  return (
                    <div key={step.id} style={{ display: 'flex', gap: 0, position: 'relative' }}>
                      {idx < steps.length - 1 && (
                        <div style={{ position: 'absolute', left: 27, top: 44, bottom: 0, width: 2, background: step.enabled ? 'var(--border-strong)' : 'var(--border)', zIndex: 0 }} />
                      )}
                      <div style={{ width: 56, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 18, flexShrink: 0 }}>
                        <div style={{
                          width: 28, height: 28, borderRadius: '50%', zIndex: 1,
                          background: step.enabled ? (isSystem ? act.color : 'var(--brand-navy)') : 'var(--bg-subtle)',
                          border: `2px solid ${step.enabled ? (isSystem ? act.color : 'var(--brand-navy)') : 'var(--border-strong)'}`,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: step.enabled ? 'white' : 'var(--text-muted)',
                          fontSize: 10, fontWeight: 700,
                        }}>
                          {step.day === 0 ? '!' : `+${step.day}`}
                        </div>
                      </div>
                      <div style={{
                        flex: 1, margin: '10px 16px 10px 0',
                        background: step.enabled ? 'var(--bg-elevated)' : 'var(--bg-subtle)',
                        border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)',
                        overflow: 'hidden', opacity: step.enabled ? 1 : 0.5, transition: 'opacity 120ms',
                      }}>
                        <div style={{ padding: '12px 14px', display: 'flex', gap: 10, alignItems: 'center' }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', minWidth: 32, textAlign: 'center', background: 'var(--bg-subtle)', padding: '2px 8px', borderRadius: 20 }}>
                            {step.day === 0 ? 'D+0' : `D+${step.day}`}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: 600, fontSize: 13 }}>{step.label}</div>
                            {step.enabled && <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{step.title}</div>}
                          </div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
                            <span className={`badge ${act.cls}`}>{act.label}</span>
                            {step.editable && (
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, color: 'var(--text-muted)' }}>
                                <input type="checkbox" checked={step.enabled} onChange={e => setStepField(step.id, 'enabled', e.target.checked)} style={{ width: 14, height: 14, accentColor: 'var(--brand-navy)' }} />
                                Ativo
                              </label>
                            )}
                          </div>
                        </div>
                        {step.enabled && step.editable && (
                          <div style={{ borderTop: '1px solid var(--border)', padding: '10px 14px', display: 'grid', gridTemplateColumns: 'auto 1fr 1fr', gap: 10, alignItems: 'end', background: 'var(--bg-subtle)' }}>
                            <div>
                              {lbl('Dia (D+)')}
                              <input type="number" min={0} max={365} value={step.day} onChange={e => setStepField(step.id, 'day', Number(e.target.value))} style={{ ...inputStyle, width: 70 }} />
                            </div>
                            <div>
                              {lbl('Canal')}
                              <select value={step.channel} onChange={e => setStepField(step.id, 'channel', e.target.value)} className="select" style={{ width: '100%', height: 34 }}>
                                <option value="email">E-mail</option>
                                <option value="whatsapp">WhatsApp</option>
                                <option value="email+whatsapp">E-mail + WhatsApp</option>
                                <option value="push">Push no painel</option>
                              </select>
                            </div>
                            <div>
                              {lbl('Assunto / mensagem')}
                              <input value={step.title} onChange={e => setStepField(step.id, 'title', e.target.value)} style={{ ...inputStyle, width: '100%' }} />
                            </div>
                          </div>
                        )}
                        {!step.editable && step.enabled && (
                          <div style={{ borderTop: '1px solid var(--border)', padding: '8px 14px', background: 'var(--bg-subtle)', fontSize: 12, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Icon name="settings" size={12} />
                            Ação do sistema — não editável · Canal: {step.channel}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Config sidebar */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="card">
              <div className="card-head"><h3>Parâmetros globais</h3></div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div>
                  {lbl('Suspender após (dias)')}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <input type="number" min={1} max={60} value={config.graceDays} onChange={setCfg('graceDays')} style={{ ...inputStyle, width: 80 }} />
                    <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>dias de atraso</span>
                  </div>
                </div>
                <div>
                  {lbl('Cancelar após (dias)')}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <input type="number" min={config.graceDays + 1} max={120} value={config.cancelDays} onChange={setCfg('cancelDays')} style={{ ...inputStyle, width: 80 }} />
                    <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>dias de atraso</span>
                  </div>
                </div>
                <div style={{ height: 1, background: 'var(--border)' }} />
                <label style={{ display: 'flex', gap: 10, cursor: 'pointer', alignItems: 'flex-start' }}>
                  <input type="checkbox" checked={config.retryPayment} onChange={setCfg('retryPayment')} style={{ width: 14, height: 14, marginTop: 2, accentColor: 'var(--brand-navy)' }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>Retentar cobrança automática</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>Cobrar o cartão cadastrado automaticamente</div>
                  </div>
                </label>
                {config.retryPayment && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, paddingLeft: 24 }}>
                    <div>{lbl('A cada (dias)')} <input type="number" min={1} max={14} value={config.retryInterval} onChange={setCfg('retryInterval')} style={{ ...inputStyle, width: '100%' }} /></div>
                    <div>{lbl('Máx. tentativas')} <input type="number" min={1} max={10} value={config.maxRetries} onChange={setCfg('maxRetries')} style={{ ...inputStyle, width: '100%' }} /></div>
                  </div>
                )}
                <div style={{ height: 1, background: 'var(--border)' }} />
                <label style={{ display: 'flex', gap: 10, cursor: 'pointer', alignItems: 'flex-start' }}>
                  <input type="checkbox" checked={config.pauseOnPayment} onChange={setCfg('pauseOnPayment')} style={{ width: 14, height: 14, marginTop: 2, accentColor: 'var(--brand-navy)' }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>Pausar régua ao receber pagamento</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>Cancela notificações pendentes</div>
                  </div>
                </label>
                <label style={{ display: 'flex', gap: 10, cursor: 'pointer', alignItems: 'flex-start' }}>
                  <input type="checkbox" checked={config.notifyAdmin} onChange={setCfg('notifyAdmin')} style={{ width: 14, height: 14, marginTop: 2, accentColor: 'var(--brand-navy)' }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>Notificar administrador</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>Receber cópia de cada ação da régua</div>
                  </div>
                </label>
                {config.notifyAdmin && (
                  <div style={{ paddingLeft: 24 }}>
                    {lbl('E-mail do admin')}
                    <input value={config.adminEmail} onChange={setCfg('adminEmail')} style={{ ...inputStyle, width: '100%' }} />
                  </div>
                )}
              </div>
            </div>

            <div className="card">
              <div className="card-head"><h3>Resumo atual</h3></div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Lojas inadimplentes</span>
                  <span className="badge danger"><span className="dot"></span>{inadimplentes.length}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-muted)' }}>MRR em risco</span>
                  <span style={{ fontWeight: 600, color: 'var(--danger)' }}>R$ {inadimplentes.reduce((a, s) => a + s.plan.price, 0).toLocaleString('pt-BR')}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Passos ativos</span>
                  <span style={{ fontWeight: 500 }}>{steps.filter(s => s.enabled).length} de {steps.length}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── TAB: Lojas em atraso ── */}
      {activeTab === 'lojas' && (
        <div className="table-wrap">
          {inadimplentes.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>
              <Icon name="check" size={28} style={{ display: 'block', margin: '0 auto 10px', opacity: 0.4 }} />
              Nenhuma loja inadimplente no momento
            </div>
          ) : (
            <table className="data">
              <thead>
                <tr>
                  <th style={{ width: '28%' }}>Loja</th>
                  <th>Plano</th>
                  <th>Dias em atraso</th>
                  <th>Etapa atual</th>
                  <th>Próxima ação</th>
                  <th style={{ textAlign: 'right' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {inadimplentes.map(s => {
                  const daysLate = Math.abs(daysBetween(s.nextDue, today));
                  const nextStep = steps.filter(st => st.enabled && st.day > daysLate)[0];
                  const currentStep = [...steps].reverse().find(st => st.enabled && st.day <= daysLate);
                  return (
                    <tr key={s.id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div style={{ width: 28, height: 28, borderRadius: 6, background: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: 'white', flexShrink: 0 }}>
                            {s.name.split(' ').filter(w => w.length > 1).slice(0, 2).map(w => w[0]).join('')}
                          </div>
                          <div>
                            <div style={{ fontWeight: 500 }}>{s.name}</div>
                            <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace' }}>{s.domain}</div>
                          </div>
                        </div>
                      </td>
                      <td>{s.plan.name} · R$ {s.plan.price}</td>
                      <td><span style={{ fontWeight: 600, color: daysLate >= 15 ? 'var(--danger)' : 'var(--warning)' }}>{daysLate} dia{daysLate !== 1 ? 's' : ''}</span></td>
                      <td>
                        {currentStep
                          ? <span className={`badge ${ACTIONS[currentStep.action]?.cls || 'info'}`}>{currentStep.label}</span>
                          : <span className="badge neutral">—</span>}
                      </td>
                      <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                        {nextStep ? `${nextStep.label} em D+${nextStep.day - daysLate}` : <span style={{ color: 'var(--danger)' }}>Nenhuma — suspender manualmente</span>}
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
                          <button className="icon-action" title="Reenviar cobrança" onClick={() => onToast && onToast(`Cobrança reenviada para ${s.name}`)}><Icon name="refresh" size={13} /></button>
                          <button className="icon-action" title="Enviar notificação" onClick={() => onToast && onToast(`Notificação enviada para ${s.name}`)}><Icon name="bell" size={13} /></button>
                          <button className="icon-action danger" title="Suspender agora" onClick={() => onToast && onToast(`${s.name} suspensa`)}><Icon name="suspend" size={13} /></button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* ── TAB: Histórico ── */}
      {activeTab === 'historico' && (
        <div className="table-wrap">
          <div className="table-toolbar">
            <span style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>Últimas ações automáticas da régua</span>
            <button className="btn sm" style={{ marginLeft: 'auto' }}><Icon name="download" size={13} />Exportar</button>
          </div>
          <table className="data">
            <thead><tr><th>Loja</th><th>Ação disparada</th><th>Canal</th><th>Resultado</th><th>Data/hora</th></tr></thead>
            <tbody>
              {[
                { store: 'Ferragens Pampulha',  action: '2° lembrete',         channel: 'WhatsApp',         result: 'Entregue', date: 'Hoje, 09:00',   ok: true  },
                { store: 'Ferragens Pampulha',  action: '1° lembrete',         channel: 'E-mail',           result: 'Aberto',   date: 'Há 4 dias',     ok: true  },
                { store: 'Aromaterapia Zen',    action: 'Aviso de suspensão',  channel: 'E-mail',           result: 'Entregue', date: 'Há 2 dias',     ok: true  },
                { store: 'Bazar Popular',       action: '1° lembrete',         channel: 'E-mail',           result: 'Bounce',   date: 'Há 3 dias',     ok: false },
                { store: 'Bazar Popular',       action: 'Vencimento',          channel: 'E-mail',           result: 'Entregue', date: 'Há 6 dias',     ok: true  },
                { store: 'Cosméticos Juá',      action: 'Suspensão automática',channel: 'Sistema',          result: 'Executado',date: 'Há 12 dias',    ok: true  },
                { store: 'Cosméticos Juá',      action: 'Aviso de suspensão',  channel: 'E-mail + WhatsApp',result: 'Entregue', date: 'Há 14 dias',    ok: true  },
              ].map((h, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 500 }}>{h.store}</td>
                  <td>{h.action}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{h.channel}</td>
                  <td>{h.ok
                    ? <span className="badge success"><span className="dot"></span>{h.result}</span>
                    : <span className="badge danger"><span className="dot"></span>{h.result}</span>}</td>
                  <td style={{ color: 'var(--text-muted)' }}>{h.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export {
  InadimplenciaPage,
};
